<template>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg p-4 sm:ml-64 mt-16">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                    <th scope="col" class="px-6 py-3">Pelaku Usaha</th>
                    <th scope="col" class="px-6 py-3">Nama Agen</th>
                    <th scope="col" class="px-6 py-3">No. HP</th>
                    <th scope="col" class="px-6 py-3">Email</th>
                    <th scope="col" class="px-6 py-3">Alamat</th>
                    <th scope="col" class="px-6 py-3">Status</th>
                    <th scope="col" class="px-6 py-3">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in paginatedUsers" :key="user.uid"
                    class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-white">{{ user.namaPelakuUsaha }}</td>
                    <td class="px-6 py-4">{{ user.namaAgen }}</td>
                    <td class="px-6 py-4">{{ user.noWhatsapp }}</td>
                    <td class="px-6 py-4">{{ user.email }}</td>
                    <td class="px-6 py-4">{{ user.alamat }}</td>
                    <td class="px-6 py-4 font-medium" :class="{
                        'text-green-600': user.status === 'active',
                        'text-red-600': user.status === 'inactive'
                    }">
                        {{ user.status }}
                    </td>
                    <td class="px-6 py-4">
                        <button v-if="user.status === 'inactive'" @click="showApproveModal(user.uid)"
                            class="text-blue-600 hover:underline">
                            Approve
                        </button>
                        <router-link v-else :to="`/transaction/${user.uid}`" class="text-green-600 hover:underline">
                            Lihat
                        </router-link>
                    </td>


                    <!-- <td class="px-6 py-4">
                        <button @click="showDeleteModal(user.uid)" class="text-red-600 hover:underline">
                            Hapus
                        </button>
                    </td> -->
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <nav class="flex items-center justify-between pt-4" aria-label="Table navigation">
            <span class="text-sm text-gray-500 dark:text-gray-400">
                Showing <span class="font-semibold text-gray-900 dark:text-white">{{ startIndex + 1 }}-{{ endIndex
                    }}</span>
                of <span class="font-semibold text-gray-900 dark:text-white">{{ users.length }}</span>
            </span>
            <ul class="inline-flex -space-x-px text-sm h-8">
                <li>
                    <button @click="prevPage" :disabled="currentPage === 1"
                        class="px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">
                        Previous
                    </button>
                </li>
                <li v-for="page in totalPages" :key="page">
                    <button @click="changePage(page)"
                        :class="{ 'text-blue-600 bg-blue-50': currentPage === page, 'hover:bg-gray-100': currentPage !== page }"
                        class="px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">
                        {{ page }}
                    </button>
                </li>
                <li>
                    <button @click="nextPage" :disabled="currentPage === totalPages"
                        class="px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">
                        Next
                    </button>
                </li>
            </ul>
        </nav>

        <div v-if="isModalOpen"
            class="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50">
            <div class="relative p-4 w-full max-w-md max-h-full bg-white rounded-lg shadow-md dark:bg-gray-700">
                <button @click="closeModal"
                    class="absolute top-3 right-3 text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 dark:hover:bg-gray-600 dark:hover:text-white">
                    ✖
                </button>
                <div class="p-4 md:p-5 text-center">
                    <svg class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        Anda yakin akan approve user ini?
                    </h3>
                    <button @click="approveUser"
                        class="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5">
                        Ya, Approve
                    </button>
                    <button @click="closeModal"
                        class="py-2.5 px-5 ml-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                        Tidak, Batalkan
                    </button>
                </div>
            </div>
        </div>


    </div>
    <!-- Toast Notification -->
    <div v-if="isToastVisible"
        class="fixed top-5 z-60 right-5 flex items-center w-full max-w-xs p-4 text-gray-500 bg-white rounded-lg shadow-sm dark:text-gray-400 dark:bg-gray-800"
        role="alert" id="toast-success">
        <div
            class="inline-flex items-center justify-center w-8 h-8 text-red-500 bg-red-100 rounded-lg dark:bg-red-800 dark:text-red-200">
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                viewBox="0 0 20 20">
                <path
                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
            </svg>
        </div>
        <div class="ml-3 text-sm font-normal">User berhasil dihapus.</div>
    </div>

</template>

<script>
import { ref, onMounted, computed } from "vue";
import { db } from "@/firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";

export default {
    setup() {
        const users = ref([]);
        const currentPage = ref(1);
        const perPage = 10; // Jumlah data per halaman
        const isModalOpen = ref(false);
        const isToastVisible = ref(false);
        const userToApprove = ref(null);

        // Fetch users dari Firestore
        const fetchUsers = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "users"));
                users.value = querySnapshot.docs.map((doc) => ({ uid: doc.id, ...doc.data() }));
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        // Tampilkan modal Approve
        const showApproveModal = (uid) => {
            userToApprove.value = uid;
            isModalOpen.value = true;
        };


        const closeModal = () => {
            isModalOpen.value = false;
            userToApprove.value = null;
        };

        // Approve user (ubah status menjadi active)
        const approveUser = async () => {
            if (userToApprove.value) {
                try {
                    await updateDoc(doc(db, "users", userToApprove.value), { status: "active" });

                    // Update status secara lokal
                    const user = users.value.find(u => u.uid === userToApprove.value);
                    if (user) user.status = "active";

                    // Tampilkan toast sukses
                    isToastVisible.value = true;
                    setTimeout(() => { isToastVisible.value = false; }, 3000);
                } catch (error) {
                    console.error("Error updating user status:", error);
                    alert("Gagal mengapprove user!");
                }
                closeModal();
            }
        };


        // Pagination logic
        const totalPages = computed(() => Math.ceil(users.value.length / perPage));
        const startIndex = computed(() => (currentPage.value - 1) * perPage);
        const endIndex = computed(() => Math.min(startIndex.value + perPage, users.value.length));
        const paginatedUsers = computed(() => users.value.slice(startIndex.value, endIndex.value));

        const changePage = (page) => {
            if (page >= 1 && page <= totalPages.value) {
                currentPage.value = page;
            }
        };

        const prevPage = () => {
            if (currentPage.value > 1) currentPage.value--;
        };

        const nextPage = () => {
            if (currentPage.value < totalPages.value) currentPage.value++;
        };

        onMounted(fetchUsers);

        return {
            users,
            isModalOpen,
            isToastVisible,
            showApproveModal,
            approveUser,
            closeModal,
            currentPage,
            paginatedUsers,
            totalPages,
            startIndex,
            endIndex,
            changePage,
            prevPage,
            nextPage
        };
    },
};
</script>
